<template>
<div>
    <div class="c-breadcrumbs" typeof="BreadcrumbList" vocab="http://schema.org/" style="margin-top: -61px;text-align: left;">
            <span property="itemListElement" typeof="ListItem"><a property="item" typeof="WebPage" title="株式会社ranryu" href="/" class="home"><span property="name">ホーム</span></a><meta property="position" content="1"></span> &gt; <span property="itemListElement" typeof="ListItem"><a property="item" typeof="WebPage" title="お問い合わせ" href="/contact/" class="post post-page"><span property="name">お問い合わせ</span></a><meta property="position" content="2"></span> &gt; <span class="post post-page current-item">送信完了</span>
        </div>
    <div class="p-section ctt-cnt aos-init aos-animate" data-aos="fade-up" data-aos-duration="1800">
        <form action="" method="post" id="form" name="myform" novalidate="novalidate">
        <p class="p-category-title">お問い合わせ</p>
        <h1 class="p-page-title" style="margin-bottom: 10px">CONTACT</h1>
        <img src="../assets/images/common/sending.png" class="contact_img">
        <!--<img src="/contact/static/images/common/contact_mail.png" class="contact_img">-->
        <br><br>
        <h2 style="font-size: 1.5em">送信が完了しました</h2>
        <br><br>
        <p class="u-center">
        お問い合わせいただきありがとうございました。 <br>
        お問い合わせいただきました内容を確認後、担当者より改めてご連絡いたします。<br>
        恐れ入りますが、今しばらくお待ちいただけますよう、宜しくお願い申し上げます。<br>
        </p>
        <br><br>
        <div class="u-center">
            <input type="button" style="-webkit-appearance: none" value="HOME" class="form-btn" v-on:click="moveToTop()">
        </div>
        </form>
    </div>
</div>
</template>

<script>
import CommonMixin from '@/mixins'

export default {
  mixins: [CommonMixin],
  mounted: function () {
    this.contactIsFinish = true
  },
  methods: {
    moveToTop () {
      window.location.href = '/'
    }
  }
}
</script>
<style>
.contact_img {
    width: 12%;
}
@media screen and (max-width:768px) {
    .contact_img {
        width: 24%;
    }
}
.sugg_content {
    margin-top: -50px
}
@media screen and (max-width:768px) {
    .sugg_content {
        margin-top: -20px
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactFinish.vue